<template>
  <div :class="['cookie-consent', 'unselectable', $route.name === 'cookie-policy' ? 'cookie-consent-transparent' : '']">
    <v-toolbar :dark="dark" :color="color" :class="['elevation-12', 'py-0']">
      <div :class="['body-1']" v-html="message" />
      <v-spacer />
      <v-btn small flat depressed dark aria-label="view-cookie-policy" :class="['px-0']" to="/cookie-policy" :title="$lang.cookiePolicy">{{ $lang.cookiePolicy }}</v-btn>
      <v-btn small aria-label="close-cookie-consent-bar" @click="dismiss" :class="['px-0']" :title="$lang.ok" :color="buttonColor">{{ $lang.ok }}</v-btn>
    </v-toolbar>
  </div>
</template>
<script>
import Cookies from 'universal-cookie'
import methods from '../mixins/methods'

export default {
  name: 'CookieConsent',
  mixins: [
    methods
  ],
  props: {
    color: {
      type: String
    },
    message: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: true
    },
    buttonColor: {
      type: String
    }
  },
  methods: {
    dismiss () {
      const cookies = new Cookies()
      cookies.set(this.$config.cookieConsent, true, {
        path: '/',
        expires: this.oneMonthFromNow()
      })
      this.$root.cookieConsent = true
    }
  }
}
</script>
<style>
.cookie-consent,
.cookie-consent .v-toolbar
{
  position: fixed;
}

.cookie-consent
{
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .8);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.cookie-consent-transparent
{
  background: none;
}

.cookie-consent .v-toolbar
{
  bottom: 0;
}

.cookie-consent:focus .v-btn,
.cookie-consent:active .v-btn
{
  transform: scale(1.15);
}
</style>



// WEBPACK FOOTER //
// src/components/cookie-consent.vue